module.exports = __webpack_public_path__ + "img/american_express.748a46d9.svg";